import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { usePersistStore, useStore } from "../store";
import { VerificationRequestService } from "../services";

interface ModalProps {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
}

const VerifyProfilePopup: React.FC<ModalProps> = ({
  show,
  onHide,
  onSuccess,
}) => {
  const { token } = usePersistStore((s: any) => s);
  const { setIsLoading } = useStore((s: any) => s);
  const [validationMessage, setValidationMessage] = useState<string>("");

  const handleSubmit = async (e: any) => {
    e?.preventDefault();
    setValidationMessage("");

    setIsLoading(true);
    let result = await VerificationRequestService.create(token);
    if (result.error) {
      setValidationMessage(result.error);
      setIsLoading(false);
      return;
    }

    setValidationMessage("");
    setIsLoading(false);
    onSuccess();
  };

  const clear = () => {
    setValidationMessage("");
    onHide();
  };

  return (
    <Modal
      className="disputeModal txt-user-cnic-picture"
      show={show}
      onHide={clear}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-start">
        <div className="d-flex justify-content-between">
          <h5>Verify your profile</h5>
          <img
            src="/assets/imgs/plus.svg"
            style={{ cursor: "pointer" }}
            onClick={clear}
            alt=""
          />
        </div>
        <hr />

        <div className="mb-1 pb-2">
          All your information will be verified by our team. Please make sure
          you have provided all the required information.
        </div>

        {validationMessage && (
          <div className="validation-message mb-2">{validationMessage}</div>
        )}

        <div className="d-flex gap-2 justify-content-end mt-3">
          <Button
            className="closeBtn"
            style={{ width: "120px" }}
            onClick={clear}
          >
            Close
          </Button>
          <button
            className="mainBtn "
            style={{ width: "120px" }}
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VerifyProfilePopup;
